import { z } from 'zod';
/**
 * Rechnung nach der Fahrt (KON-246, KON-247): Schließt der Fahrer eine Fahrt ab, erstellt Wirkia daraus die Rechnung und schickt sie dem Kunden. Eine Fahrt ist schon mit „Fahrgast angetroffen“
 * zahlungspflichtig, die Rechnung entsteht aber erst nach dem Fahrtende, weil bis dahin noch etwas dazukommen kann (geänderte Route, mehr Kilometer, Wartezeit, Unfall). Der Mandant schaltet
 * die Automatik in der Einrichtung ein oder aus und passt den Text der Mail an.
 */
export const RIDE_INVOICE_PLACEHOLDERS = [
    { key: 'Kunde', label: 'Name des Kunden' },
    { key: 'Rechnungsnummer', label: 'Nummer der Rechnung' },
    { key: 'Betrag', label: 'Rechnungsbetrag brutto, zum Beispiel 95,00 €' },
    { key: 'Auftrag', label: 'Auftragsnummer' },
    { key: 'Fahrt', label: 'Fahrt mit Datum, Abholung und Ziel' },
    { key: 'Firma', label: 'Name Ihres Unternehmens' },
    { key: 'Beglichen', label: 'Hinweis, wie die Rechnung beglichen wurde (leer, wenn noch ein Betrag offen ist)' },
];
export const DEFAULT_RIDE_INVOICE_SUBJECT = 'Ihre Rechnung {{Rechnungsnummer}}';
export const DEFAULT_RIDE_INVOICE_BODY = `Guten Tag {{Kunde}},

vielen Dank, dass Sie mit uns gefahren sind. Anbei erhalten Sie die Rechnung {{Rechnungsnummer}} über {{Betrag}} zu Ihrer Fahrt ({{Fahrt}}, Auftrag {{Auftrag}}).

{{Beglichen}}

Bei Fragen melden Sie sich gern, am besten mit der Rechnungsnummer.

Mit freundlichen Grüßen
{{Firma}}`;
export const DEFAULT_RIDE_INVOICE_SETTINGS = { auto: true, subject: DEFAULT_RIDE_INVOICE_SUBJECT, body: DEFAULT_RIDE_INVOICE_BODY };
const known = new Set(RIDE_INVOICE_PLACEHOLDERS.map((p) => p.key));
/** Schreibweise {{Name}} ohne Leerzeichen, Namen aus der Liste oben */
const unknownIn = (text) => [...text.matchAll(/\{\{\s*([^{}]*?)\s*\}\}/g)].map((m) => m[1]).filter((k) => !known.has(k));
const template = (what, min, max) => z
    .string()
    .trim()
    .min(min, `${what} fehlt`)
    .max(max, `${what} ist zu lang`)
    .superRefine((v, ctx) => {
    const bad = unknownIn(v);
    if (bad.length > 0)
        ctx.addIssue({ code: 'custom', message: `Unbekannter Platzhalter: ${bad.map((k) => `{{${k}}}`).join(', ')}` });
});
export const rideInvoiceSettingsInput = z
    .object({
    auto: z.boolean(),
    subject: template('Der Betreff', 3, 200),
    body: template('Der Text', 10, 5000).refine((v) => v.includes('{{Rechnungsnummer}}'), 'Der Text braucht den Platzhalter {{Rechnungsnummer}}'),
})
    .strict();
/** Setzt die Werte in den Text ein. Unbekannte Platzhalter bleiben stehen, leere Absätze, die dadurch entstehen, fallen weg. */
export function fillRideInvoiceTemplate(text, values) {
    const filled = text.replace(/\{\{\s*([^{}]*?)\s*\}\}/g, (whole, key) => (key in values ? (values[key] ?? '') : whole));
    return filled.replace(/\n{3,}/g, '\n\n').trim();
}
//# sourceMappingURL=ride-invoice.js.map